<template>
  <div id="extend-index" :class="{'active': indexActive}">
    <div class="card">
      <div class="card-header">
        <h5>목차선택</h5>
      </div>
      <div class="card-body">
        <ul class="item-list">
          <li class="checkbox index-category"
              v-for="item in itemList"
              :key="item.id"
          >
            <label>
              <input type="checkbox" v-model="data[item.id]" @change="toggleIndex(item)">
              <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
              {{ item.name }}
            </label>
            <ul v-if="item.sub" class="sub-item-list">
              <li class="checkbox sub-item margin-top-16"
                  v-for="subItem in item.sub"
                  :key="subItem.id"
              >
                <label>
                  <input type="checkbox" v-model="data[subItem.id]" @change="toggleSubIndex(item)">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  {{ subItem.name }}
                </label>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <a href="#" class="index-toggle" @click.prevent="$emit('toggle', !indexActive)">
      <i :class="toggleIconClass" style="font-size: 12px; font-weight: normal;"></i>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'extend-index',
    props: {
      value: {
        type: Object,
        default () {
          return {}
        }
      },
      indexActive: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        data: {},
        itemList: [
          {
            id: 'plant_analysis',
            name: '사업지분석',
            sub: [
              { id: 'plant_summary', name: '사업지개요' },
              { id: 'spot_photo_file', name: '현장사진' },
              { id: 'review_result', name: '검토의견' }
            ]
          },
          {
            id: 'power_analysis',
            name: '발전량분석'
          },
          {
            id: 'apparatus_plan',
            name: '주요 기자재 계획',
            collapse: true,
            sub: [
              { id: 'module', name: '모듈' },
              { id: 'inverter', name: '인버터' }
            ]
          },
          {
            id: 'plot_plan_file',
            name: '배치도'
          },
          {
            id: 'business_profit',
            name: '견적서 및 수익',
            collapse: true,
            sub: [
              { id: 'business_cost_file', name: '견적서' },
              { id: 'profit_option', name: '수익' }
            ]
          },
          {
            id: 'schedule_file',
            name: '추진일정'
          },
          {
            id: 'reference_file',
            name: '레퍼런스'
          },
          {
            id: 'company_info',
            name: '회사정보'
          },
          {
            id: 'supplement',
            name: '부록'
          }
        ]
      }
    },
    computed: {
      toggleIconClass () {
        const arrowClass = this.indexActive ? 'glyphicon-menu-left' : 'glyphicon-menu-right'
        return ['glyphicon', arrowClass]
      }
    },
    watch: {
      'value': {
        handler (val) {
          this.data = val
        }
      },
      'indexActive': {
        handler (val) {
          // PC 스크린이 아닐 경우에만 실행한다. (1200px 미만)
          if (!this.$parent.checkScreenWidth()) {
            const isShowScroll = val ? 'hidden' : 'auto'
            this.setScrollOverflow(isShowScroll)
          }
        }
      }
    },
    methods: {
      toggleIndex (item = {}) {
        if (item.sub) {
          for (let i in item.sub) {
            this.data[item.sub[i].id] = this.data[item.id]
          }
        }
      },
      toggleSubIndex (item = {}) {
        const data = _.cloneDeep(this.data)
        const subCheckboxes = item.sub
        const isAllChecked = (() => {
          // 자식 체크박스가 하나라도 체크가 안되어 있을 경우 False 값을 반환한다.
          for (let i in subCheckboxes) {
            const subID = subCheckboxes[i].id
            if (!data[subID]) {
              return false
            }
          }

          return true
        })()

        // 자식 체크박스가 모두 체크되어 있는지에 따라 부모 체크박스 활성화 여부 처리
        this.data[item.id] = isAllChecked
      },
      setScrollOverflow (state = 'auto') {
        document.getElementsByTagName('body')[0].setAttribute('style', `overflow: ${state};`)
      }
    },
    created () {
      this.data = this.value
    },
    beforeDestroy () {
      this.setScrollOverflow('auto')
    }
  }
</script>

<style lang="scss" scoped>
  $extend-index-width: 220px;
  $hide-position: -220px;
  $grey-bg-color: #f7f9fa;
  $box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 1px 1px 0 rgba(0, 0, 0, 0.23);
  $active-color: #26507a;

  #extend-index {
    position: fixed;
    top: 64px;
    left: $hide-position;
    width: $extend-index-width;
    height: 100%;
    background-color: $hzc-white;
    z-index: 9;
    transition: all .5s ease;

    @media (max-width: 767px) {
      width: calc(100% - 40px);
      left: calc(-100% + 40px);
    }

    ul {
      list-style: none;
    }

    // 목차선택 활성 시
    &.active {
      left: 0;

      .index-toggle {
        left: 220px;
        @media (max-width: 767px) {
          left: calc(100% - 1px);
          opacity: 1;
        }
      }
    }

    .card {
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-shadow: $z-depth-01;
      float: left;
    }

    .card-header {
      padding: 16px;
      border-bottom: 1px solid $hzc-gray-03;

      h5 {
        margin: 0;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.13;
        letter-spacing: -0.8px;
        color: $font-color;
      }
    }

    .card-body {
      height: calc(100% - 148px);
      overflow-x: hidden;
      overflow-y: auto;

      @media (max-width: 991px) {
        height: calc(100% - 112px);
      }
    }

    .item-list {
      padding: 0;
      margin: 0;

      .index-category {
        padding: 16px;
        border-bottom: 1px solid $border-color;

        &:last-child {
          border: none;
        }

        .sub-item-list {
          padding-left: 32px;

          .sub-item {
            font-weight: normal;

            .sub-item-name {
              color: #2e3338;
            }
          }
        }
      }
    }

    .index-toggle {
      position: absolute;
      top: calc(50% - 96px);
      width: 25px;
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      color: $hzc-gray-07;
      text-align: center;
      background-color: $hzc-white;
      border-width: 1px 1px 1px 0;
      border-style: solid;
      border-color: $hzc-gray-04;
      box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.12);
      float: left;

      @media (max-width: 767px) {
        opacity: 0.75;
      }
    }

    .checkbox {
      margin: 0;

      label,
      label a {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 21px;
        letter-spacing: -0.3px;
        color: $header-color;
      }

      .cr {
        width: 20px;
        height: 20px;
        margin: 1px 6px 0 0;
      }

      .cr-icon {
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ExtendIndex.vue